// Layout values of canvas blocks without the block models, so style
// modules (vanilla-extract) can read them without loading the store.
import { darkThemeV2, lightThemeV2 } from '@streamlain/theme/v2';

export const BLOCK_CHILDREN_CONTAINER_PADDING_LEFT = 24;
export const EDGELESS_BLOCK_CHILD_PADDING = 24;
export const EDGELESS_BLOCK_CHILD_BORDER_WIDTH = 2;
/** Default white-note surface used by neutral cards on the edgeless canvas. */
export const EDGELESS_CANVAS_CARD_BACKGROUND = `light-dark(${lightThemeV2['edgeless/note/white']}, ${darkThemeV2['edgeless/note/white']})`;

/** Inset surface for canvas-card chrome (headers, footers and add controls). */
export const EDGELESS_CANVAS_CARD_CONTRAST_BACKGROUND = `light-dark(${lightThemeV2['layer/background/secondary']}, ${darkThemeV2['layer/background/primary']})`;
export const EDGELESS_CANVAS_CARD_SHADOW =
  'var(--streamlain-canvas-card-shadow, var(--streamlain-note-shadow-box))';
export const STREAMLAIN_NOTE_LAYOUT_READY_ATTR =
  'data-streamlain-note-layout-ready';
